export default {
	tenantId: "fubon_uat",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "fubon--uat"
	}
}
